module.exports = " <footer class=\"container text-center\">\n    <p class=\"footer-p\">Copyright  &copy;  2018 - webuters.com &middot;</p>\n  </footer>\n\n"